export type InfoGroupBookingAction =
  | { type: 'SET_IS_FETCHING_GROUP_CONTENT' }
  | { type: 'SET_FETCH_GROUP_CONTENT_FAILED' }
  | { type: 'SET_GROUP_CONTENT', content: Julius.Website.GroupPageViewModel };

  export const setIsFetching = (): InfoGroupBookingAction => ({
    type: 'SET_IS_FETCHING_GROUP_CONTENT',
  });

  export const setFetchFailed = (): InfoGroupBookingAction => ({
    type: 'SET_FETCH_GROUP_CONTENT_FAILED',
  });

  export const setContent = (content: Julius.Website.GroupPageViewModel): InfoGroupBookingAction => ({
    content,
    type: 'SET_GROUP_CONTENT',
  });


// WEBPACK FOOTER //
// ./src/pages/InfoGroupBookingPage/Redux/actions.tsx